import React from 'react';
import { Box, IconButton, InputBase, Modal, Popover, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import QRCode from "qrcode.react";
import copy from "copy-to-clipboard";
import LinkIcon from '@mui/icons-material/Link';
import { isMiniprogram } from "../../utils/deviceDetect";
import { useJSBridgeAction } from "@realsee/jsbridge-x/lib/react/hooks";
import Toast from '../_ui/Toast'

function LiveShareModal (props) {
	const [qrcodeEl, setQrcodeEl] = React.useState(null)
	const [miniprogramEl, setMiniprogramEl] = React.useState(null)
	const { actionShare } = useJSBridgeAction()
	
	const handleQrcodeOpen = (evt) => {
		setQrcodeEl(evt.currentTarget)
	}
	
	const handleQrcodeClose = () => {
		setQrcodeEl(null)
	}
	
	const handleMiniprogramOpen = (evt) => {
		if (!isMiniprogram) return
		actionShare(props.shareConfig)
		setMiniprogramEl(evt.currentTarget)
	}
	
	const handleMiniprogramClose = () => {
		setMiniprogramEl(null)
	}
	
	const handleCopyLink = () => {
		copy(props.shareConfig.shareLink)
		Toast.success('操作成功')
	}
	
	const handleClose = () => {
		props.onClose()
	}
	
	// TODO 抽象icon share
	return (
		<Modal open={props.open}>
			<div className="modal__wrap">
				<div className="modal__header">
					<div className="share">分享</div>
					<IconButton onClick={handleClose} className="close" sx={{color: 'black'}}><CloseIcon fontSize="small" /></IconButton>
				</div>
				<div className="modal__body">
					<div className="link-icon-list">
						<Box>
							<IconButton onClick={handleQrcodeOpen} sx={{backgroundColor: '#f1f3f4', color: 'black'}}><QrCodeScannerIcon/></IconButton>
							<Popover
								open={Boolean(qrcodeEl)}
								anchorEl={qrcodeEl}
								onClose={handleQrcodeClose}
								anchorOrigin={{
									vertical: 'center',
									horizontal: 'center'
								}}
							>
								<Typography sx={{ p: 2 }}>
									<QRCode
										value={props.shareConfig.shareLink}
										level='H'
										includeMargin={true}
									/>
								</Typography>
							</Popover>
						</Box>
						{/* bridge分享 api 暂不支持,先隐藏 */}
						{/*{isMiniprogram && <Box sx={{marginLeft: '10px'}}>*/}
						{/*	<IconButton onClick={handleMiniprogramOpen} sx={{backgroundColor: '#f1f3f4', color: 'black'}}><LinkIcon/></IconButton>*/}
						{/*	<Popover*/}
						{/*		open={Boolean(miniprogramEl)}*/}
						{/*		anchorEl={miniprogramEl}*/}
						{/*		onClose={handleMiniprogramClose}*/}
						{/*		anchorOrigin={{*/}
						{/*			vertical: 'center',*/}
						{/*			horizontal: 'center'*/}
						{/*		}}*/}
						{/*	>*/}
						{/*		<Typography sx={{ p: 2 }}>*/}
						{/*			<div className="tip">*/}
						{/*				<p>点击屏幕右上角'...'</p>*/}
						{/*				<p>即可分享带看</p>*/}
						{/*			</div>*/}
						{/*		</Typography>*/}
						{/*	</Popover>*/}
						{/*</Box>}*/}
					</div>
					<Box className="link-copy link-content" >
						<InputBase
							disabled={true}
							className="link"
							value={props.shareConfig.shareLink}
							sx={{padding: '0 4px'}}
						/>
						<IconButton
							onClick={handleCopyLink}
							className="copy" sx={{fontSize: '16px', color: 'black'}}>复制</IconButton>
					</Box>
				</div>
				<div className="modal__footer"></div>
			</div>
		</Modal>
	);
}

export default LiveShareModal;
